"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Jun 28 2018
 */

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Determines whether site is of type physical store or online shop.
 *
 * @author JMe
 * @author JMr
 * @author Radek Beran
 */


var SiteType;

(function (SiteType) {
  SiteType["Physical"] = "Physical";
  SiteType["Online"] = "Online";
})(SiteType = exports.SiteType || (exports.SiteType = {}));
/**
 * General representation of site (also known as store or warehouse).
 *
 * @author JMe
 * @author Radek Beran
 */


var Site =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(Site, _DomainObject_1$Domai);

  /**
   * @param id the internal id
   * @param externalId the external id of site, i.e. from source data
   * @param address Street + number, City, ZIP
   * @param companyId
   * @param type
   * @param formatId
   */
  function Site(id, externalId, address, companyId, type, formatId) {
    var _this;

    _classCallCheck(this, Site);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Site).call(this));
    _this.id = id;
    _this.externalId = externalId;
    _this.address = address;
    _this.companyId = companyId;
    _this.type = type;
    _this.formatId = formatId;
    return _this;
  }

  return Site;
}(DomainObject_1.DomainObject);

exports.Site = Site;